let navEl;

function setButtonLabel(button, isExpanded) {
  const { labelExpanded, labelNotExpanded } = button.dataset;
  // eslint-disable-next-line no-param-reassign
  button.querySelector('.title').innerHTML = isExpanded ? labelExpanded : labelNotExpanded;
}

function handleClick(event) {
  const buttonEl = event.currentTarget;
  const buttonControls = buttonEl.getAttribute('aria-controls').split(' ');
  const submenuEl = navEl.querySelector(`#${buttonControls[0]}`);
  const isExpanded = buttonEl.getAttribute('aria-expanded') === 'true';

  document.body.classList.toggle('local-nav-panel--expanded', !isExpanded);
  buttonEl.setAttribute('aria-expanded', !isExpanded);
  submenuEl.setAttribute('aria-hidden', isExpanded);
  setButtonLabel(buttonEl, !isExpanded);
}

function init() {
  navEl = document.querySelector('.section--local-navigation-strip');

  if (navEl) {
    [...navEl.querySelectorAll('[aria-controls]')].forEach((buttonEl) => {
      buttonEl.addEventListener('click', handleClick);
    });
  }
}

export default {
  init,
};
